const setCustomer = {
  applysetCustomer: () => 'Payment/setCustomer',
};
export default setCustomer;
